import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ContactInfo } from '../components/ContactInfo';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <>
      <section className="relative min-h-screen flex flex-col justify-center items-center bg-tcp-black overflow-hidden px-4 sm:px-6 lg:px-8 py-16" data-id="element-143">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-tcp-red/15 blur-[150px] rounded-full pointer-events-none" data-id="element-144" />

        <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-145">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-146">
            {/* Logo */}
            <div className="flex justify-center mb-6" data-id="element-147">
              <img src="https://cdn.magicpatterns.com/uploads/jGwG5Z9Yokuafa2USNXiZs/TCP_LOGO_-_1_-_Edited.png" alt="The Christmas Palace - Est. 1992" className="w-[224px] md:w-[294px] lg:w-[350px] h-[70px] md:h-[84px] lg:h-[98px] object-contain object-center" style={{
              background: 'transparent'
            }} data-id="element-148" />
            </div>

            <h1 className="font-serif md:text-6xl lg:text-7xl font-bold text-white mb-8 text-[32px]" data-id="element-149">
              Commercial Christmas Décor <br className="hidden md:block" data-id="element-150" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-tcp-gray" data-id="element-151">
                & Installation Services
              </span>
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="md:text-xl text-tcp-gray max-w-3xl mx-auto mb-12 font-light text-[14px]" data-id="element-152">
            The Christmas Palace has been supplying and installing premium
            holiday décor for commercial properties across the U.S. for over 35
            years. Hotels, retail centers, corporate campuses, and municipal
            installations — we handle projects of any scale.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-153">
            <Link to="/maintenance" className="w-full sm:w-auto group relative inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-tcp-red rounded-sm overflow-hidden transition-all hover:bg-tcp-darkred shadow-[0_0_20px_rgba(183,29,35,0.25)] hover:shadow-[0_0_30px_rgba(183,29,35,0.4)]" data-id="element-154">
              <span className="relative z-10" data-id="element-155">Request Maintenance</span>
            </Link>
            <Link to="/quote" className="w-full sm:w-auto group relative inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-tcp-red rounded-sm overflow-hidden transition-all hover:bg-tcp-darkred shadow-[0_0_20px_rgba(183,29,35,0.25)] hover:shadow-[0_0_30px_rgba(183,29,35,0.4)]" data-id="element-156">
              <span className="relative z-10" data-id="element-157">Request Quote</span>
            </Link>
          </motion.div>
        </div>
      </section>

      <ContactInfo data-id="element-158" />
      <Footer data-id="element-159" />
    </>;
}